<div class="modal-header border-0">
  <h4 class="modal-title pull-left">Add Profile Picture</h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span>
  </div>
</div>

<div class="modal-body">
  <div *ngIf="showSizeError" class="something_wrong_col">
    <h6><img src="assets/images/info_icon.svg" draggable="false" alt="info">Something went wrong</h6>
    <p>The image should not be bigger than 3 MB. Please resize or choose another image.</p>
  </div>

  <!-- <input type="file" [accept]="'image/*'" (change)="onSelect($event.target.files[0])" /> -->
  <div class="custom-dropzone drag_outer" ngx-dropzone [accept]="'image/*'" [multiple]="false" (change)="onSelect($event)" [maxFileSize]="imageMaxSize">
    <ngx-dropzone-label>
      <div class="drag_and_drop_col">
        <img src="assets/images/folder.svg" draggable="false" alt="folder">
        <div>
          <h6>Drag & Drop File here </h6>
        <label>Or Select a File</label>
        </div>
      </div>
    </ngx-dropzone-label>
    <ngx-dropzone-image-preview class="profile_pic"  ngProjectAs="ngx-dropzone-preview" *ngFor="let f of files" [file]="f">
    </ngx-dropzone-image-preview>
  </div>
</div>
<!-- <div class="modal-footer">
  <button class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
  <button class="btn btn-rbv warning" (click)="onConfirm()">
    Submit
  </button>
</div> -->

